import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["modal"];

    connect() {
      if (this.hasModalTarget && this.element.dataset.showInPopup === "true") {
        requestAnimationFrame(() => this.openModalOnLoad());
      }
    }

    openModal(e) {
      if (e) e.preventDefault();
      this.openModalOnLoad();
    }

    openModalOnLoad() {
      const modalController = this.application.getControllerForElementAndIdentifier(
        this.modalTarget,
        "admin--modal"
      );

      if (modalController) {
        modalController.open();
      } else {
        console.error("Modal controller not found for element:", this.modalTarget);
      }
    }
}
